import { gql, useLazyQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import IsoToDateTime from "../../../CommonFunction/IsoDateTime";
import { replaceUnderscore } from "../../../CommonFunction/common";
import { LoadTable, Loading } from "../../Components";
import { Tabs } from "../../Components/AdminRequestSupportComponents/Tabs";
import HeaderDiv from "../../Components/HeaderDiv/HeaderDiv";
import useFetchTableData from "../../custom_hooks/useFetchTableData";
import "../CommonPage.scss";

const queryfunction = (fields) => {
  const query = gql`
  query getPendingPayment($Status: String!)  {
    PaymentRequestRelatedToStatus(Status: $Status)  {
      _id
      ${fields?.join(" ")}
    }
  }
  `;

  return query;
};
export const Payment = () => {
  const Tab = useSelector((store) => store.SelectedTabData.tab);
  const [loadingState, setLoading] = useState(true);
  const [formdata, setformdata] = useState([]);
  const Key = "User Role";
  const [FetchPaymentData, { loading, error, data }] = useLazyQuery(queryfunction([]), {
    variables: {
      Status: "Payment Processed",
      Status: Tab === "Pending" ? "Pending for Process" : Tab === "Processed" ? "Payment Processed" : "",
    },
  });

  const dispatch = useDispatch();
  useFetchTableData(queryfunction, FetchPaymentData, setLoading, Key);

  useEffect(() => {
    let updatedData = data?.PaymentRequestRelatedToStatus?.map((el) => {
      let obj = { ...el };
      delete obj.__typename;
      obj.Status = replaceUnderscore(obj.Status);
      if (obj?.createdAt) {
        obj.createdAt = IsoToDateTime(obj?.createdAt);
      }
      if (obj?.updatedAt) {
        obj.updatedAt = IsoToDateTime(obj?.updatedAt);
      }

      return obj;
    });
    setformdata(updatedData);
    setLoading(false);
  }, [data]);

  useEffect(() => {
    dispatch({ type: "TabData", payload: { tab: "Pending" } });
  }, []);
  let statusTab = [{ name: "Pending" }, { name: "Processed" }, { name: "Process Done" }];
  return (
    <>
      <p className="pageTitle">Payment Process</p>
      <div className="hr1ForPageTitle"></div>
      <Tabs tabs={statusTab} />

      <HeaderDiv title={""} TableKey={Key} MoreActions={{Is_Process:true}} />
      {loadingState || loading ? (
        <Loading />
      ) : !formdata?.length ? (
        <p className="DataNotAvailable">Data not Available</p>
      ) : (
        <>
          <LoadTable data={formdata} loading={loading} error={error} title={Tab} />
        </>
      )}
    </>
  );
};
